import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels',
	exact: true,
};
